import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, PenToolIcon, TrendingUpIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Hablemos',
    description: 'Una simple conversación por WhatsApp',
    icon: MessageCircleIcon
  }, {
    num: '02',
    title: 'Diseñamos',
    description: 'Estrategia personalizada para tu nicho',
    icon: PenToolIcon
  }, {
    num: '03',
    title: 'Creces',
    description: 'Nuevos clientes llegan a tu puerta',
    icon: TrendingUpIcon
  }];
  return <section id="como-funciona" className="py-20 lg:py-24 bg-secondary" data-id="element-113">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <div className="text-center mb-16" data-id="element-115">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-dark" data-id="element-116">
            Así de fácil es empezar
          </motion.h2>
        </div>

        <div className="relative" data-id="element-117">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden md:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-primary/20 -translate-y-1/2 z-0" data-id="element-118" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-119">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={step.num} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} className="flex flex-col items-center text-center" data-id="element-120">
                  <div className="w-20 h-20 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 relative border-4 border-secondary" data-id="element-121">
                    <Icon className="w-8 h-8 text-primary" data-id="element-122" />
                    <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-accent text-white font-bold text-sm flex items-center justify-center shadow-md" data-id="element-123">
                      {step.num}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-dark" data-id="element-124">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 max-w-[250px]" data-id="element-125">
                    {step.description}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}